import axios from 'axios';
import { API_BASE } from '../config';

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

export const submitFormResponse = async (formData, isFileUpload = false) => {
  try {
    const config = isFileUpload
      ? {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...authHeaders().headers
          }
        }
      : authHeaders();

    const res = await axios.post(`${API_BASE}form-responses`, formData, config);
    return res.data;
  } catch (err) {
    console.error('❌ خطا در ارسال پاسخ:', err);

    // پیام خطا از سرور یا پیام عمومی
    const message =
      err.response?.data?.message ||
      'خطا در ارسال پاسخ. لطفاً اتصال یا اطلاعات فرم را بررسی کنید.';

    throw err; // در صورت نیاز به استفاده بالا
  }
};

// دریافت فرم بر اساس pageId (برای فرم ساز)
export const getFormByPageId = async (pageId) => {
  try {
    const res = await axios.get(`${API_BASE}forms/page/${pageId}`, authHeaders());
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) {
      return null; // یعنی فرمی هنوز ساخته نشده
    }
    throw err;
  }
};


// ایجاد فرم جدید (برای صفحه‌ای که هنوز فرم ندارد)
// ایجاد فرم
export const createForm = async (formData) => {
  try {
    const res = await axios.post(`${API_BASE}forms`, formData, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ایجاد فرم:', err);
    throw new Error(err.response?.data?.message || 'ایجاد فرم با خطا مواجه شد.');
  }
};

// به‌روزرسانی فرم
export const updateForm = async (id, formData) => {
  if (!id) {
    throw new Error('شناسه فرم معتبر نیست.');
  }
  try {
    const res = await axios.put(`${API_BASE}forms/${id}`, formData, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در به‌روزرسانی فرم:', err);
    throw new Error(err.response?.data?.message || 'ویرایش فرم با خطا مواجه شد.');
  }
};

// حذف فرم
export const deleteForm = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE}forms/${id}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در حذف فرم:', err);
    throw new Error(err.response?.data?.message || 'حذف فرم با خطا مواجه شد.');
  }
};

// دریافت کاربران اختصاص‌داده‌شده به فرم
export const getAssignedUsers = async (formId) => {
  try {
    const res = await axios.get(`${API_BASE}forms/${formId}/assigned`, authHeaders());
    return res.data.assignedTo;
  } catch (err) {
    console.error('خطا در دریافت کاربران فرم:', err);
    throw new Error(err.response?.data?.message || 'خطا در دریافت کاربران.');
  }
};

// اختصاص یک کاربر به فرم
export const assignUserToForm = async (formId, userId) => {
  try {
    const res = await axios.post(`${API_BASE}forms/${formId}/assign`, { userId }, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در اختصاص کاربر:', err);
    throw new Error(err.response?.data?.message || 'خطا در اختصاص کاربر.');
  }
};

// حذف اختصاص یک کاربر
export const unassignUserFromForm = async (formId, userId) => {
  try {
    const res = await axios.delete(`${API_BASE}forms/${formId}/unassign`, {
      ...authHeaders(),
      data: { userId }
    });
    return res.data;
  } catch (err) {
    console.error('خطا در حذف اختصاص کاربر:', err);
    throw new Error(err.response?.data?.message || 'خطا در حذف کاربر.');
  }
};

// دریافت درخت برای دسترسی فرم‌ها
export const getTreeForAccess = async ({ page = 1, limit = 20, type, startDate, endDate, search } = {}) => {
  try {
    const res = await axios.get(`${API_BASE}forms/tree-for-access`, {
      ...authHeaders(),
      params: { page, limit, type, startDate, endDate, search }
    });
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت درخت دسترسی:', err);
    throw new Error('خطا در دریافت ساختار درختی.');
  }
};

// دریافت کاربران واجد شرایط برای اختصاص به فرم
export const getEligibleViewers = async (formId) => {
  try {
    const res = await axios.get(`${API_BASE}forms/access-users/${formId}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در دریافت کاربران مجاز:', err);
    throw new Error(err.response?.data?.message || 'خطا در دریافت کاربران مجاز.');
  }
};

// اختصاص گروهی کاربران به فرم
export const assignUsersToForm = async (formId, userIds) => {
  try {
    const res = await axios.post(`${API_BASE}forms/assign-users/${formId}`, { userIds }, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در اختصاص گروهی کاربران:', err);
    throw new Error(err.response?.data?.message || 'خطا در اختصاص کاربران.');
  }
};

export const getMyForms = async (params = {}) => {
  try {
    const res = await axios.get(`${API_BASE}forms/getmyforms`, {
      headers: authHeaders().headers,
      params
    });
    return res.data;
  } catch (err) {
    console.error('❌ خطا در دریافت فرم‌های من:', err);
    throw err;
  }
};

export const getFormById = async (formId) => {
  try {
    const res = await axios.get(`${API_BASE}forms/${formId}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('❌ خطا در دریافت فرم:', err);
    throw err;
  }
};

export const getMyFormResponse = async (formId, subjectId) => {
  try {
    const config = {
      ...authHeaders(),
      params: subjectId ? { subjectId } : {}
    };

    const res = await axios.get(
      `${API_BASE}form-responses/${formId}/me`,
      config
    );
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) return null;
    console.error('❌ خطا در دریافت پاسخ کاربر:', err);
    throw err;
  }
};


